import React from 'react';

const ContactText = () => {
  return (
    <div className='contact-text'>
      <h4>Tell us about your business</h4>
      <p className='mb-5'>At Akysec, we're dedicated to helping businesses like yours navigate the complex landscape of information security. We understand that every organisation has unique challenges and goals, and we're here to provide tailored solutions that fit your needs. We're eager to learn more about your business and how we can assist you in safeguarding your sensitive data, mitigating risks, and ensuring compliance.</p>
      <h4>How can we help you?</h4>
      <p>Take a moment to share with us some details about your business and your specific security concerns. The more information you provide, the better we can understand your situation and propose effective strategies. Your privacy is of utmost importance to us, and all information shared will be treated confidentially.</p>
    </div>
  )
}

export default ContactText